import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {

  @Input() title: string;
  @Input() contentTitle: string;
  @Input() footerTitle: string;
  private _content: string;

  /** Normalisé à chaque affectation : le message peut arriver après l'ouverture de la modale. */
  @Input()
  set content(content: string) {
    this._content = typeof content === 'string' ? content.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '\n') : content;
  }

  get content(): string {
    return this._content;
  }

  /** Message en cours de récupération : un indicateur remplace le contenu. */
  @Input() loading = false;
  @Input() url: string;
  @Input() link: string;
  @Input() valider: boolean = false;
  @Input() OkOuRetour: boolean = false;
  @Input() retour: boolean = false;

  public onClose: boolean;

  constructor(private modalService: NgbModal,public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  close(){
    this.activeModal.dismiss(this.onClose);
  }

  exitModal(bool:boolean){
    this.onClose = bool;
    this.close();
  }


}

